import mixpanel from 'mixpanel-browser'

const KEY =
  process.env.NODE_ENV !== 'production'
    ? '39e4889667203569aedea2a070c6c25a'
    : '35b1945d536afe6d9fec4de732aee548'
mixpanel.init(KEY, {
  debug: true,
})
export default mixpanel



// WEBPACK FOOTER //
// ./src/plugins/mixPanel.js